import { render } from "./StudentHome.vue?vue&type=template&id=48f5c90c&scoped=true"
import script from "./StudentHome.vue?vue&type=script&lang=js"
export * from "./StudentHome.vue?vue&type=script&lang=js"

import "./StudentHome.vue?vue&type=style&index=0&id=48f5c90c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f5c90c"]])

export default __exports__